import React, {Component}  from 'react';
import {connect} from 'react-redux';

import UM from 'UM';
import $ from '$'


class Editor extends Component{
    paste = (e,d)=>{
        // Prevent the default pasting event and stop bubbling
        e.preventDefault();
        e.stopPropagation();

        // Get the clipboard data--
        let paste = (e.clipboardData || window.clipboardData).getData('text/html');
        let paste1 = (e.clipboardData || window.clipboardData).getData('text/plain');
        if(paste===''){paste = paste1}

        let replaceArr = [
            'span', 'meta', 'u', 'b', 'audio', 'ul',
            'li', 'i', 'html', 'body', 'div', 'a', 'col', 'table', 'th', 'tr', 'td',
            '!--StartFragment--', '!--EndFragment--', '!DOCTYPE', 'font', '!DOCTYPE',
            'big', 'br', 'button', 'canvas', 'code', 'dd', 'del',
            'details', 'dl', 'dt', 'em', 'embed', 'footer', 'form', 'frame',
            'header', 'hr', 'input', 'label',
            'link', 'ol', 'script', 'nav', 'script',
            'section', 'strong', 'tbody', 'video',
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        ]
        replaceArr.forEach((d)=>{
            let reg = eval(`/<${d}([\\s][\\S\\s]*?)*?>/gi`)
            let reg1 = eval(`/<\\/${d}>/gi`)
            paste = paste.replace(reg,'');
            paste = paste.replace(reg1,'');
        })

        paste = paste.replace(/<head>[\S\s]*?<\/head>/gi, '');

        paste = paste.replace(/<p[\S\s]*?>/gi, '<p>');
        paste = paste.replace(/<iframe[\S\s]*?>/gi, ($,$1)=>{
            let data = /data-latex=\"(\\frac\{[\S\s]*?\}\{[\S\s]*?\})\"/.exec($)
            if($.match('class="mathquill-embedded-latex"')){
                return `<span class="mathquill-embedded-latex">${data[1]}</span>`
            }else{
                return ''
            }
        });
        paste = paste.replace(/<\/iframe>/gi, '');

        // Find the cursor location or highlighted area
        const selection = window.getSelection();

        // Cancel the paste operation if the cursor or highlighted area isn't found
        if (!selection.rangeCount) return false;
        var fragment = document.createDocumentFragment();
        $(fragment).append(paste)
        // Paste the modified clipboard content where it was intended to go
        selection.getRangeAt(0).insertNode(fragment);
        //$("#tip").html(paste)
    }
    componentDidMount() {
       
        let toolbarFormula1 = ['fullscreen'];
        let toolbarFormula2 = [
            // 'source',
            'undo','redo','|','removeformat','|','xssFilter'];
        let toolbarBasic = [];
        if (!this.props.hideFullscreen) {
            toolbarBasic.push(...toolbarFormula1);
        }

        toolbarBasic.push(...toolbarFormula2);
        let toolbarFinal=[]
        if(this.props.inputMethod!='text'){
        		toolbarFinal=toolbarBasic.concat((this.props.toolbar?this.props.toolbar:[]))
        }
        const ue = this.ue = UM.getEditor(this.props.id, {
            UEDITOR_HOME_URL: "/static/lib/umeditor",
            initialFrameWidth: this.props.width,
            initialFrameHeight: (this.props.height?this.props.height:this.props.subject == '1' ? 34 : 100),//语文输入框窄
            zIndex: this.props.inModal ? 1001 : 999,
            toolbar: toolbarFinal,
            autoHeight: false,
            autoFloatEnabled: !this.props.inModal,
            removeFormatAttributes: 'class,style,lang,width,height,align,hspace,valign',
        });
        let __this = this
        // ue.addListener("contentChange",() => {
        //     console.log('内容改变:'+ue.getContent());
        // });
        document.getElementById(this.props.id).addEventListener("paste", __this.paste);
    }

    componentWillUnmount() {
        this.ue.destroy();
        // if(this.props.subject!=='0'){
        let __this = this
        document.getElementById(this.props.id).removeEventListener("paste", __this.paste);
        // }
    }
    render(){
        return(
            <script type="text/plain" name="content" id={this.props.id}></script>
        );
    }
}
Editor.defaultProps = {
    content: '',
    width: '100%',
    // height: 100,
    inModal: false,
    // toolbarBasic: [
    //     'fullscreen','undo','redo','|','removeformat','|', 'xssFilter'
    // ],
};
const mapStateTopProps = (state) => {
    let subject
    if(state.entryData){
        subject= state.entryData.subject
    }
    if(state.user){
        subject= state.user.subject
    }
    return {
        subject:subject

    }
};
const mapDispatchToProps = dispatch => {
    return {
    }
};

export default connect (mapStateTopProps,mapDispatchToProps)(Editor)


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/common/editor/view.js